////
/// ============================================================================
/// COMPONENT / Progressbar
/// ============================================================================
///
/// @link https://codyhouse.co/ds/components/app/reading-progressbar
/// @group components
////

export default () => {
    let wrapper = document.querySelector('.js-readingprogress');

    if (!wrapper) {
        return;
    }

    let progress = document.querySelector('.js-readingprogress-bar');
    let content = document.querySelector('.js-readingprogress-content');
    let progressEvent = false;

    // Init indicator
    setProgressIndicator();

    // Wait for font to be loaded - reset progress bar
    if (document.fonts) {
        document.fonts.ready.then(updateProgress);
    }

    // Listen to window resize - update progress
    window.addEventListener('resize', updateProgress);

    // Listen to the window scroll event - update progress
    window.addEventListener('scroll', updateProgress);

    function updateProgress() {
        if (progressEvent) {
            return;
        }

        progressEvent = true;

        if (window.requestAnimationFrame) {
            window.requestAnimationFrame(setProgressIndicator);
        } else {
            setTimeout(setProgressIndicator, 250);
        }
    }

    function setProgressIndicator() {
        // Se il contenuto è troppo breve, non deve fare nulla
        if (content.offsetHeight <= window.innerHeight) {
            wrapper.setAttribute("aria-hidden", "true");
            progressEvent = false;

            return;
        }

        let contentBCR = content.getBoundingClientRect();

        // Nasconde il wrapper quando il contenuto è fuori dal viewport
        if (contentBCR.top >= 0 || contentBCR.bottom <= 0) {
            wrapper.setAttribute("aria-hidden", "true");
        } else {
            wrapper.setAttribute("aria-hidden", "false");
        }

        let value = (contentBCR.top >= 0) ? 0 : 100 * (0 - contentBCR.top) / (content.offsetHeight - window.innerHeight);
        progress.setAttribute('value', value);

        progressEvent = false;
    }
};
